import { defineStore } from 'pinia'
import { computed, ref, watchEffect } from 'vue'
import { useAuth } from '@/entities/Auth'
import { useLoadEvents } from '@/entities/Events'
import { cloneDeep } from 'lodash'

export const useEventsNotification = defineStore('event_notification', () => {
  const auth = useAuth()

  const open = ref(false)
  const isNew = ref(true)
  const data = ref<any[]>([])

  /** Вычисляем группу объектов пользователя */
  const objectId = computed(() => {
    return Number(auth.user?.object_group.id)
  })

  const filter = computed(() => ({
    is_read: 'false',
    page: 1,
    per_page: 100,
  }))

  const loadData = () => {
    const result = useLoadEvents(filter.value, objectId)

    watchEffect(() => {
      if (result.data.value) {
        data.value = cloneDeep(result.data.value.data || [])
      }
    })

    return result
  }

  /**
   * Функция открытия списка оповещений
   */
  const openModal = () => {
    open.value = true
    isNew.value = false
  }

  /**
   * Функция закрытия списка оповещений
   */
  const closeModal = () => {
    open.value = false
  }

  return {
    open,
    isNew,
    filter,
    data,

    loadData,
    openModal,
    closeModal,
  }
})
